import React from 'react'
import styled from 'styled-components'
import { quoteDetailed } from '../utils/Regex'

// TODO: remove double code
const TextBaseDiv = styled.div`
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`
const TextItemQuoteDiv = styled(TextBaseDiv)`
  padding: 10px;
  font-family: monospace;
  font-size: 13px;
  color: #3bffd1;
  display: flex;
  overflow: auto;
  flex-direction: column;
  border-left: 2px solid #77d3fd;
  margin-left: 4px;
  cursor: pointer;
  white-space: break-spaces;
`
const TextItemQuoteDataDiv = styled(TextBaseDiv)`
  gap: 10px;
  font-family: monospace;
  font-size: 13px;
  color: #3bffd1;
  border-radius: 3px;
  display: flex;
  overflow: auto;
  flex-direction: row;
  >p {
    font-style: italic;
    margin: 2px 5px;
  }
`

export const showMsgByNum = (e:React.MouseEvent, msgID: number) => {
  e.stopPropagation()
  const requestedMessage = document.querySelector(`[data-id="${msgID}"]`)

  if (!requestedMessage) {
    return
  }

  requestedMessage.scrollIntoView({ behavior: 'smooth', block: 'center' })
}

export interface QuoteProps {
  author: string
  created: string
  text: string
  nestedQuotes?: JSX.Element[]
  target: number
}

const TextItemQuote: React.FC<React.PropsWithChildren<QuoteProps>> = React.memo(({ author, created, text, target, children }) => (
  <TextItemQuoteDiv onClick={(e) => showMsgByNum(e, target)} data-type="quote">
    <TextItemQuoteDataDiv>
      <p>@{author}</p>
      <p>{created}</p>
    </TextItemQuoteDataDiv>
    {children}
    <TextItemQuoteDataDiv>
      <p>{text}</p>
    </TextItemQuoteDataDiv>
  </TextItemQuoteDiv>
))


export const Quote: React.FC<{ data: string }> = ({ data }) => {
  const quoteData: RegExpMatchArray | null = data.match(quoteDetailed)

  if (!quoteData) {
    return null
  }

  const [, author, created, target, quoteContent] = quoteData

  const nestedData: RegExpMatchArray | null = quoteContent.match(quoteDetailed)

  if (!nestedData) {
    return <TextItemQuote data-target={target} target={Number(target)} author={author} created={created} text={quoteContent} />
  }

  const nestedText = quoteContent.slice(nestedData[0].length)

  return (
    <TextItemQuote data-target={target} target={Number(target)} author={author} created={created} text={nestedText}>
      <Quote data={nestedData[0]} />
    </TextItemQuote>
  )
}
